import { Fonts, Images, Colors } from '../../../shared/theme/';
import styleButton from '../../../shared/components/rbh-button/styles';

export default {
  forgot_layout: {
    height: '100vh',
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
  },
  forgot_content: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  },
  forgotBox: {
    marginTop: '100px',
    width: '380px',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px'
  },
  buttonBox: {
    ...styleButton.buttonGradient,
    width: '100%',
    marginBottom: '16px'
  },
  iconBack: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginRight: '4px',
  },
  iconBox: {
    width: '62.81px',
    height: '24px'
  },
  iconImage: {
    width: '100%',
    height: '100%'
  },
  successBox: {
    marginTop: '100px',
    width: '380px',
    height: '370px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px',
  },
  contentModal: {
    padding: 40,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  successIconBox: {
    width: '100%',
    height: '100%'
  },
  successIconImage: {
    fontSize: Fonts.size.text70,
    color: Colors.successGreen,
    paddingTop: '28px'
  },
};
